import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "spinner", "icon"]
  static values = { persist: Boolean }

  connect() {
    this.defaultLabel = this.hasLabelTarget ? this.labelTarget.textContent : null
    this.element.addEventListener("submit", this.#startOnSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.#startOnSubmit)
  }

  start() {
    this.#setLoading()
  }

  finish(event) {
    if (this.#redirectedSubmission(event)) return
    if (this.#persistedSuccessfulSubmission(event)) {
      this.#keepLoading()
      return
    }

    this.#restore()
  }

  #startOnSubmit = (event) => {
    if (event.defaultPrevented) return

    this.#setLoading()
  }

  #setLoading() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.setAttribute("disabled", "disabled")
    }
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    if (this.hasIconTarget) this.iconTarget.classList.add("hidden")
    if (this.hasLabelTarget) this.labelTarget.textContent = this.buttonTarget.dataset.loadingLabel
  }

  #redirectedSubmission(event) {
    return event.detail?.fetchResponse?.response?.redirected === true
  }

  #persistedSuccessfulSubmission(event) {
    return this.persistValue && event.detail?.success === true
  }

  #keepLoading() {
    this.#setLoading()
    requestAnimationFrame(() => this.#setLoading())
  }

  #restore() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
      this.buttonTarget.removeAttribute("disabled")
    }
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    if (this.hasIconTarget) this.iconTarget.classList.remove("hidden")
    if (this.hasLabelTarget) this.labelTarget.textContent = this.defaultLabel
  }
}
